import React from 'react';
import { LayoutDashboard, Briefcase, TrendingUp, BrainCircuit, Award } from 'lucide-react';

const Sidebar = ({ activeSection, setActiveSection }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'portfolio', label: 'Portfolio Overview', icon: Briefcase },
    { id: 'market', label: 'Market Data', icon: TrendingUp },
    { id: 'ai', label: 'AI Insights', icon: BrainCircuit },
    { id: 'track', label: 'Track Record', icon: Award },
  ];

  return (
    <div
      className="fixed left-0 top-0 h-screen w-64 flex flex-col"
      style={{ backgroundColor: '#D5E2F2' }}
    >
      <div className="p-6 mb-4">
        <h1 className="text-2xl font-bold text-slate-900">BLACKROCK</h1>
        <p className="text-sm text-slate-600 mt-1">Portfolio Analytics</p>
      </div>
      <nav className="flex-1 px-3">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeSection === item.id;
          return (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => setActiveSection(item.id)}
              className={`w-full flex items-center px-4 py-3 mb-2 rounded-lg text-left transition-all duration-200 ${
                isActive
                  ? 'bg-white text-slate-900 shadow-sm font-semibold'
                  : 'text-slate-600 hover:bg-white/50 hover:text-slate-900'
              }`}
            >
              <Icon className="w-5 h-5 mr-3" strokeWidth={isActive ? 2.5 : 2} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
      <div className="p-4 text-xs text-slate-500 text-center border-t border-slate-200/50">
        <p>© 2026 TradeBoard Pro</p>
      </div>
    </div>
  );
};

export default Sidebar;